/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ebr_Linked_Offers_NInputs */

const cs_ebr_linked_offers_n = /** @type {(inputs: Ebr_Linked_Offers_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nabídek`)
};

const en_ebr_linked_offers_n = /** @type {(inputs: Ebr_Linked_Offers_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} offers`)
};

/**
* | output |
* | --- |
* | "{count} offers" |
*
* @param {Ebr_Linked_Offers_NInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_linked_offers_n = /** @type {((inputs: Ebr_Linked_Offers_NInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Linked_Offers_NInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_linked_offers_n(inputs)
	return cs_ebr_linked_offers_n(inputs)
});